module.exports = __webpack_public_path__ + "img/15.6f967c2f.png";